// extracted by mini-css-extract-plugin
export default {"wrapper":"DualImage_wrapper__KQPUh","image":"DualImage_image__rwkM6"};